import { SHOW_HEADER_LOGO, HIDE_HEADER_LOGO } from "./types";

const getInitialState = () => {
  return { headerLogoShow: false };
};

export default (state = getInitialState(), action) => {
  switch (action.type) {
    case SHOW_HEADER_LOGO:
      return {
        ...state,
        headerLogoShow: true,
      };
    case HIDE_HEADER_LOGO:
      return {
        ...state,
        headerLogoShow: false,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/services/ui/logo/reducer.js